import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../api/baseUrl";
import { addPrescription } from "../../../../../../redux/diagnosestate/diagnoseAction";
interface Diagnose {
  _id: string;
  diagnose: string;
}

interface FormData {
  drugsId: string;
  drugsIds: string;
  doseId: string;
  frequency: string;
  duration: string;
  drugs: string;
  dose: string;
  doseIds: string;
  type: string;
}

function PrescriptionForm() {
  const dispatch = useDispatch();
  const { ID } = useParams();
  const initialFormData: FormData = {
    drugsId: "",
    drugsIds: "",
    drugs: "",
    dose: "",
    doseId: "",
    doseIds: "",
    frequency: "",
    duration: "",
    type: "",
  };
  const [formData, setformData] = useState(initialFormData);

  const [data, setData] = useState([]);

  useEffect(() => {
    baseUrl
      .get("/client/prescription/prescription/findAllPrescription")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to fetch diagnoses. Please try again.");
      });
  }, []);

  const diagnoseOptions = useMemo(
    () =>
      data.map((item: any) => (
        <option
          value={item._id + "/" + item.drugs + "/" + item.type}
          key={item._id}
        >
          {item.drugs}
        </option>
      )),
    [data]
  );
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "drugsIds") {
      setformData((prev) => ({
        ...prev,
        [name]: value,
        drugsId: value.split("/")[0],
        drugs: value.split("/")[1],
        type: value.split("/")[2],
      }));
    } else if (name === "doseIds") {
      setformData((prev) => ({
        ...prev,
        [name]: value,
        doseId: value.split("/")[0],
        dose: value.split("/")[1],
      }));
    } else {
      setformData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (
        !formData.drugsId ||
        !formData.doseIds ||
        !formData.frequency ||
        !formData.duration
      ) {
        toast.error("Please select a drugs.");
        return;
      }
      const response = await baseUrl.patch(
        "/client/treatments/prescription/addprescription",
        formData,
        {
          headers: { treatmentid: ID },
        }
      );

      dispatch(
        addPrescription({
          ...formData,
          createdAt: response.data.data.createdAt,
          _id: response.data.data._id,
        })
      );
      setformData(initialFormData);
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {/* Drugs */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Drugs *</label>
          <select
            name="drugsIds"
            value={formData.drugsIds}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg border border-gray-600 focus:outline-none transition-all text-xs bg-slate-50"
          >
            <option value="">Select Drug</option>
            {diagnoseOptions}
          </select>
        </div>

        {/* Dose */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Dose *</label>
          <select
            name="doseIds"
            value={formData.doseIds}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg border border-gray-600 focus:outline-none transition-all text-xs bg-slate-50"
          >
            <option value="">Select Dose</option>
            {data
              ?.filter((item: any) => item._id === formData.drugsId)
              ?.map((filteredItem: any) => filteredItem.dose)
              ?.flat()
              .map((item: any, i: number) => (
                <option key={i} value={item + "/" + item}>
                  {item}{formData.type}
                </option>
              ))}
          </select>
        </div>

        {/* Frequency */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Frequency *</label>
          <select
            name="frequency"
            value={formData.frequency}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg border border-gray-600 focus:outline-none transition-all text-xs bg-slate-50"
          >
            <option value="">Select Frequency</option>
            <option value="bd">BD (Twice daily)</option>
            <option value="tds">TDS (Three times daily)</option>
            <option value="qds">QDS (Four times daily)</option>
            <option value="nocte">Nocte (At night)</option>
            <option value="sos">SOS (As needed)</option>
            <option value="stat">Stat (Immediately)</option>
            <option value="stat , 100mg/nocte">Stat, 100mg/nocte</option>
            <option value="mane">Mane (Morning)</option>
          </select>
        </div>

        {/* Duration */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Duration (Days) *</label>
          <select
            name="duration"
            value={formData.duration}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 rounded-lg border border-gray-600 focus:outline-none transition-all text-xs bg-slate-50"
          >
            <option value="">Select Duration</option>
            <option value="1">1 Day</option>
            <option value="2">2 Days</option>
            <option value="3">3 Days</option>
            <option value="4">4 Days</option>
            <option value="5">5 Days</option>
            <option value="7">7 Days</option>
            <option value="10">10 Days</option>
            <option value="14">14 Days</option>
          </select>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-2 rounded-lg bg-gradient-to-r from-teal-500 to-emerald-600 text-white font-medium text-xs hover:shadow-lg hover:shadow-teal-200 transition-all disabled:opacity-50"
        >
          {isSubmitting ? "Adding..." : "Add Prescription"}
        </button>
      </div>
    </form>
  );
}

export default PrescriptionForm;
